import React from 'react';
import './Loader.scss';
import loadImage from '../pineapple-loader.png';
const Loader = () => {
    return (

        <div className='loader'>
            <img className='spinner me-4' src={loadImage} />
            Loading...
        </div>
    );
};
export default Loader;
